import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Sync as SyncIcon,
  LocalShipping as LocalShippingIcon,
  CompareArrows as CompareArrowsIcon
} from '@mui/icons-material';

function ComponentSelector() {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTabFromPath = () => {
    const path = location.pathname;
    if (path.includes('/tracking-sync/tracking')) return 1;
    if (path.includes('/tracking-sync/mapping')) return 2;
    if (path.includes('/tracking-sync/settings')) return 3;
    return 0;
  };

  const [activeTab, setActiveTab] = React.useState(getActiveTabFromPath());

  React.useEffect(() => {
    setActiveTab(getActiveTabFromPath());
  }, [location]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

    switch (newValue) {
    case 0:
      navigate('/tracking-sync/operations');
      break;
    case 1:
      navigate('/tracking-sync/tracking');
      break;
    case 2:
      navigate('/tracking-sync/mapping');
      break;
    case 3:
      navigate('/tracking-sync/settings');
      break;
    default:
      navigate('/tracking-sync/operations');
    }
  };

  return (
    <Box>
      <Paper elevation={0} sx={{ mb: 3, borderRadius: 2, overflow: 'hidden' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab icon={<SyncIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Operations" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
          <Tab icon={<LocalShippingIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Tracking" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
          <Tab icon={<CompareArrowsIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Mapping" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
          <Tab icon={<SettingsIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Settings" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
        </Tabs>
      </Paper>
    </Box>
  );
}

export default ComponentSelector;
